const amountOfNotesOnPage = 20;

export default amountOfNotesOnPage;
